import { useEffect } from 'react'
import { treks } from '../data/treks'

// Derive the trek name from the current URL path (e.g. "/manaslu-circuit" ->
// "Manaslu Circuit"). Falls back to 'general' on non-trek pages.
function trekNameFromPath() {
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, '')
  const trek = treks.find(t => t.slug === slug)
  return trek ? trek.name : 'general'
}

// One global click listener that fires GA4 + Meta Pixel events whenever any
// WhatsApp link (href contains wa.me/ or api.whatsapp.com) is clicked, anywhere
// on the site. Implemented once here instead of in each of the ~18 inline CTAs.
//
// Notes:
// - Never calls preventDefault, so the WhatsApp link opens exactly as before.
// - gtag/fbq are fire-and-forget queue pushes — they don't delay the navigation.
// - Guarded with if(window.…) + try/catch so a blocker (e.g. Brave) can't throw.
export default function useWhatsAppTracking() {
  useEffect(() => {
    function handleClick(e) {
      const link = e.target.closest ? e.target.closest('a[href]') : null
      if (!link) return
      const href = link.getAttribute('href') || ''
      if (!href.includes('wa.me/') && !href.includes('api.whatsapp.com')) return

      const trek = trekNameFromPath()
      try {
        if (window.gtag) window.gtag('event', 'whatsapp_click', { trek })
      } catch (_) { /* analytics blocked — ignore */ }
      try {
        if (window.fbq) window.fbq('trackCustom', 'WhatsAppClick', { trek })
      } catch (_) { /* analytics blocked — ignore */ }
    }

    // Capture phase so we still fire even if an inner handler stops propagation.
    document.addEventListener('click', handleClick, true)
    return () => document.removeEventListener('click', handleClick, true)
  }, [])
}
